/*
 * payment-channels translations for the "ar" locale.
 *
 * Split out of locales/ar.js so this feature's copy stops shipping to
 * every route in the app. See locales/payment-channels/index.js.
 */
export default {
    hero_section: {
      title: "اكتشف طرق الدفع الأساسية مع كونتكت",
      subtitle: "في كونتكت، خلّينا موضوع التمويل أبسط من أي وقت فات",
      description:
        "بخبرة 25 سنة في السوق، دايمًا بنطوّر خدمات الدفع الإلكتروني علشان نوفّرلك راحة أكتر، واختيارات دفع تناسب أسلوب حياتك.دلوقتي تقدر تدفع بسهولة من خلال تطبيق كونتكت ناو، وده في أي وقت ومن أي مكان.استمتع بالمرونة، والسهولة، وراحة البال مع شبكة الدفع المتكاملة من كونتكت، اللي مصممة علشان تسهّل عليك كل خطوة.",
    },
    img_paragraph_section: {
      title: "ازاي تدفع اقساطك مع كونتكت بسهولة وفي أي وقت ؟",
      subtitle: "",
      description: `<p>مع كونتكت، دفع الأقساط بقى أسهل من أي وقت فات ومن غير أي تعقيد. وفرنا لك أكتر من وسيلة دفع مرنة علشان تختار اللي يناسبك وتدفع في الوقت والمكان اللي يريحك. تقدر تسدّد قسطك بكل سهولة من خلال تطبيق Contact Now بخطوات سريعة وآمنة, أو من خلال زيارة أقرب فرع لكونتكت. كل الطرق مصممة علشان توفّر عليك الوقت وتخلّي تجربة الدفع سلسة، من غير طوابير ولا مجهود.</p>`,
      cta1: "ادفع من خلال تطبيق Contact Now ، وسيب الباقي علينا!",
      cta2: "أو من خلال فروعنا",
      cta_btn: "فروعنا",
    },
    channels_section: {
      title: "طرق دفع ذكية ومتكاملة من كونتكت",
      description: `
  <p><strong>استمتع</strong> بخدمات دفع إلكتروني سلسة وآمنة من كونتكت عن طريق تطبيق كونتكت ناو وبالاضافة الي توافر خدمات الدفع من خلال الفروع.</p>
  <p>دلوقتي تقدر تسدّد أقساطك أونلاين بكل سهولة من خلال قنوات الدفع الرقمية زي فوري، إنستا باي، أو بي، وكمان منصات تانية موثوقة كتير.</p>
`,
      channel_subtitle:
        "عندنا اختيارات كتير للدفع الإلكتروني (التحصيل الألكتروني) زي:",
      channels: [
        {
          title: "تطبيق كونتكت ناو",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/contact_now.svg",
        },
        {
          title: "الأهلي ممكن",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/ahly_momken.svg",
        },
        {
          title: "انستا باي",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/instapay.svg",
        },
        {
          title: "بي (بساطة)",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/bee_basata_ar.svg",
        },
        {
          title: "مصاري (بساطة)",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/bee_basata_ar.svg",
        },
        {
          title: "ضامن",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/damen.svg",
        },
        {
          title: "فوري",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/fawry.svg",
        },
        {
          title: "أوباي",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/opay.svg",
        },
        {
          title: "سوبر باي",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/superpay.svg",
        },
      ],
      cta: "وكلهم جاهزين تستخدمهم دلوقتي!",
      soon: "وكمان قريب هتقدر تدفع من خلال :",
      soon_list: `
        <ul style="display: flex; flex-wrap: wrap; gap: 40px; list-style-type: disc; padding: 0; margin: 0;">
  <li style="display: list-item;">خالص</li>
  <li style="display: list-item;">البريد المصري</li>
</ul>

        `,
    },
    contact_now_section: {
      title1: "استمتع بتجربة دفع سهلة",
      title2: "وسلسة مع Contact Now",
      subtitle:
        "في كونتكت، دايمًا بنسعى نسهّل عليك كل عملية دفع، نخليها أسرع، أبسط، ومريحة أكتر.",
      description: `
            <p><strong>من</strong> خلال تطبيق <strong>Contact Now</strong>، تقدر تدير وتسدّد أقساطك بكل سهولة وفي أي وقت يناسبك.</p>
            <p>وفرنالك كمان طرق دفع واختيارات كتير علشان تختار الأنسب ليك، ومع التطبيق هتلاقي كمان إرشادات ونصايح وتنقّل سهل يخلي رحلتك المالية أريح من أي وقت فات.</p>
            <p>وكمان جمعنا بين المرونة والابتكار، واشتغلنا على تجربة رقمية متكاملة علشان نوفرلك خدمة مريحة ومناسبة ليك في كل خطوة.</p>
`,
    },
    branches: {
      title: "فروع كونتكت الرئيسية",
      description: `
        <p><strong>في</strong> كونتكت، نلتزم بأن نكون دائمًا حيثما تحتاج إلينا. تنتشر فروعنا الرئيسية في مختلف أنحاء مصر لتوفير سهولة الوصول وتقديم خدمة متميزة. يضم كل فرع فريقًا من الخبراء المتخصصين الجاهزين لتقديم الإرشاد المهني والحلول المصممة لتلبية احتياجاتك.</p>

<p>وإذا لم يكن من الممكن زيارتنا شخصيًا، يمكنك إدارة وثائقك ومدفوعاتك في أي وقت ومن أي مكان عبر تطبيق 
  <a href="https://onelink.to/frpjkg" target="_blank" rel="noopener noreferrer" style="color:#2D317F; text-decoration: underline; text-decoration-skip-ink: none;"><strong>Contact Now</strong></a>.
</p>

<p>سواء تواصلت معنا في أحد فروعنا أو عبر الإنترنت، فإن كونتكت تضمن لك تجربة سلسة، موثوقة في كل خطوة من الطريق.</p>

<p>
  تفضل بزيارة 
  <a href="our-branches" style="color:#2D317F; text-decoration: underline; text-decoration-skip-ink: none;">اقرب فرع </a>
  إليك أو أتمم مدفوعاتك بسرعة وأمان عبر تطبيق 
  <a href="https://onelink.to/frpjkg" target="_blank" rel="noopener noreferrer" style="color:#2D317F; text-decoration: underline; text-decoration-skip-ink: none;"><strong>Contact Now</strong></a>.
</p>

            `,
    },
    faq: {
      title: "الأسئلة الشائعة",
      faqs: [
        {
          question:
            "إيه هي قنوات الدفع الإلكتروني أو طرق الدفع المتاحة مع كونتكت؟",
          answer: `
  <p>تقدر تسدد أقساطك مع كونتكت بسهولة عن طريق مجموعة متنوعة من قنوات الدفع الإلكتروني اللي تناسبك في أي وقت وأي مكان.</p>

  <p>تقدر تستعمل تطبيق <strong>ContactNow</strong> لتجربة رقمية سهلة وسريعة، أو تدفع من خلال شركائنا المعتمدين: الأهلي ممكن، إنستا باي، مصاري، ضامن، فوري، أوباي، وسوبر باي.</p>

  <p>وقريب جدًا هنوفر قنوات سداد جديدة لكونتكت زي أمان، سهل، والبريد المصري.</p>
`,
        },
        {
          question: "إيه هو تطبيق كونتكت ناو وإزاي أقدر أسدد أقساطي عليه؟",
          answer: `
  <p>ContactNow هو التطبيق الرسمي من كونتكت واللي بيسهّل عليك سداد الأقساط عبر الإنترنت بطريقة بسيطة وآمنة.</p>
  <p>التطبيق بيجمع كل خدماتك المالية والتأمينية في مكان واحد.</p>

  <strong>خطوات الدفع على ContactNow:</strong>

  <ul>
    <li>افتح تطبيق كونتكت ناو وسجّل دخولك.</li>
    <li>من الصفحة الرئيسية، اختار Pay Your Bills.</li>
    <li>اختار Installments عشان تشوف المبالغ المستحقة ومواعيد السداد.</li>
    <li>راجع تفاصيل الدفع زي القيمة، التاريخ، وجدول الأقساط.</li>
    <li>اختار طريقة الدفع اللي تناسبك ووافق على المبلغ.</li>
    <li>أكّد العملية واستلم إيصال الدفع الرقمي فورًا.</li>
  </ul>
`,
        },
        {
          question: "إزاي أقدر أدفع أقساطي عن طريق فوري؟",
          answer: `
  <p>تقدر تدفع عن طريق فوري سواء من خلال تطبيق myFawry أو في أي فرع من فروع Fawry Plus أو المنافذ اللي عليها شعار فوري.</p>

  <strong>عن طريق تطبيق myFawry:</strong>
  <ul>
    <li>ادخل على الخدمات المالية > البنوك والخدمات المالية > الأقساط > كونتكت.</li>
    <li>اختار نوع القسط اللي عايز تسدده (سيارات - تعليم - تمويل عقاري - وغيرها).</li>
    <li>اكتب رقمك القومي.</li>
    <li>اختار طريقة الدفع.</li>
    <li>أكّد العملية وهتوصلك رسالة بتأكيد الدفع فورًا.</li>
  </ul>

  <p>من خلال فروع فوري أو منافذ البيع:</p>
  <ul>
    <li>روح لأي منفذ عليه شعار فوري.</li>
    <li>سلّم الكاشير رقمك القومي.</li>
    <li>ادفع نقدي أو بكارت.</li>
    <li>استلم إيصال الدفع فورًا.</li>
  </ul>

  <p>ملاحظة: فوري بيضيف رسوم بسيطة على كل عملية.</p>
`,
        },
        {
          question: "إزاي أقدر أدفع أقساطي عن طريق إنستا باي؟",
          answer: `
            <p>مع إنستا باي، تقدر تسدد أقساطك بسهولة وفي أي وقت من خلال موبايلك أونلاين.</p>

<strong>خطوات الدفع:</strong>
<ul>
  <li>افتح تطبيق InstaPay واضغط على Bill Payment.</li>
  <li>من قائمة الخدمات، اختار الخدمات المالية &gt; Contact.</li>
  <li>حدد نوع القسط اللي عايز تسدده.</li>
  <li>أدخل الرقم القومي والمبلغ المطلوب.</li>
  <li>راجع التفاصيل واضغط تأكيد بإدخال الـ PIN الخاص بيك.</li>
</ul>

<p>ملاحظة: في حالة إن العملية نجحت وماظهرتش في حسابك، اتواصل مع البنك برقم العملية.</p>
            `,
        },
        {
          question: "هل في طرق دفع جديدة جاية قريب؟",
          answer: `
            <p>أكيد! إحنا دايمًا بنطوّر خدمات الدفع الإلكتروني مع كونتكت علشان نسهّل عليك.</p>

<p>قريب جدًا هتقدر تدفع من خلال أمان وسهل، وكمان البريد المصري خلال الشهور الجاية.</p>

<p>تابعنا على موقعنا أو تطبيق كونتكت ناو علشان تعرف أول بأول كل جديد.</p>
`,
        },
        {
          question: "أعمل إيه لو الدفع ما تمّش أو اتأخر؟",
          answer: `
            <p>لو عملية الدفع ما ظهرتش فورًا أو مكتوب إنها قيد المراجعة، اتبع الخطوات دي:</p>
<ul>
  <li>راجع حالة العملية في التطبيق (ناجحة - مرفوضة - قيد التنفيذ).</li>
  <li>احتفظ بإيصال الدفع سواء كان ورقي أو إلكتروني.</li>
  <li>في حالة العملية اترفضت، المبلغ بيرجع تلقائي لحسابك. لو ما حصلش، اتواصل مع البنك.</li>
</ul>

<p>للمساعدة من كونتكت:</p>
<ul>
  <li>تقدر تتواصل معانا من خلال تطبيق <b>ContactNow</b>، أو موقعنا الإلكتروني، أو كلمنا على 16177.</li>
  <li>وكمان تقدر تروح لأي فرع من فروع كونتكت.</li>
</ul>

<p>دعم قنوات الدفع:</p>
<ul>
  <li>فوري: عن طريق تطبيق myFawry</li>
  <li>إنستا باي: <a href="https://www.instapay.eg" target="_blank">www.instapay.eg</a></li>
  <li>مصاري: 16994 / <a href="https://www.e-masary.com" target="_blank">www.e-masary.com</a></li>
  <li>سهل: 0235372501 / <a href="https://sahlpay.app" target="_blank">sahlpay.app</a></li>
  <li>ضامن: <a href="https://www.damen.com.eg" target="_blank">www.damen.com.eg</a> أو من خلال تطبيق Damen Cash.</li>
  <li>أو باي: <a href="https://opayeg.com" target="_blank">opayeg.com</a> أو من خلال تطبيق Opay Egypt</li>
</ul>
`,
        },
        {
          question: "ليه أختار قنوات الدفع مع كونتكت لسداد الأقساط؟",
          answer: `
            <p>لأن كونتكت بتقدملك أكتر قنوات سداد متنوعة في مصر علشان تختار الطريقة اللي تريحك، سواء أونلاين أو في المنافذ.</p>

<ul>
  <li><b>راحة ومرونة:</b> ادفع في أي وقت ومن أي مكان من خلال التطبيقات أو أكتر من 500 ألف منفذ بيع.</li>

  <li><b>تجربة متكاملة:</b> من خلال <b>ContactNow</b>، تقدر تدير تمويلك وتدفع أقساطك وتستفيد من خدمات التأمين في مكان واحد.</li>

  <li><b>ابتكار رقمي:</b> أكتر من 24 سنة خبرة وشراكات قوية مع أهم بوابات الدفع في مصر زي فوري وإنستا باي.</li>

  <li><b>ثقة وخبرة:</b> كونتكت من أكبر شركات التمويل غير المصرفي في مصر بخبرة طويلة ومصداقية عالية.</li>
</ul>
`,
        },
      ],
    },
    cta_section: {
      title: "كل اللي محتاجه على بعد ضغطة واحدة. ",
      subtitle: "ادفع بسهولة من تطبيق كونتكت ناو, والباقي علينا.",
    },
  };
